import { SectionDataSourcesAsin } from "./SectionDataSourcesAsin";
import { SectionDataSourcesMetrics } from "./SectionDataSourcesMetrics";
import { SectionDataSourcesCosmo } from "./SectionDataSourcesCosmo";

export const SectionDataSources = () => (
  <>
    <SectionDataSourcesAsin />
    <SectionDataSourcesMetrics />
    <SectionDataSourcesCosmo />
  </>
);
